module.exports = __webpack_public_path__ + "img/source03_b3.c10d3b11.png";